<template>
  <div>
    <b-row class="mb-1">
      <b-col md="12" class="mt-2">
        <h4>Drag and drop Leads between columns to update status</h4>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col md="4">
        <b-form-input
          v-model="searchKeyword"
          placeholder="Search Opportunities..."
          class="mr-2"
        ></b-form-input>
      </b-col>
      <b-col md="4">
        <b-form-select
          v-model="selectedLeadCustomer"
          :options="leadCustomerOptions"
          class="mr-2"
        ></b-form-select>
      </b-col>
      <b-col md="4" class="justify-content-end">
        <b-button variant="primary" to="/leads/leads-add">Add Lead</b-button>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-center mb-1">
      <b-spinner
        variant="success"
        label="Spinning"
        block
        v-if="loadingpipe"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <div class="card p-1" v-if="!loadingpipe">
      <div class="kanban-board">
        <div
          v-for="(stage, index) in stages"
          :key="index"
          :class="['kanban-column', 'text-center', 'p-1', getStageClass(stage)]"
        >
          <h3>{{ stage }}</h3>
          <draggable
            :list="filteredTasks[stage]"
            group="tasks"
            @end="onDragEnd(stage, $event)"
            class="list-group"
            :data-stage="stages[index]"
          >
            <div
              v-for="task in filteredTasks[stage]"
              :key="task.id"
              :data-id="task.id"
              class="list-group-item my-2 shadow-sm"
            >
              <div class="task-title">{{ task.name }}</div>
              <div class="text-center my-1">{{ task.leadclient }}</div>
              <div v-if="stage !== 'NEW'" class="task-description">
                Description: {{ task.description }}
              </div>
              <b-badge
                v-if="stage === 'NEW'"
                :variant="statusVariant(task.leadStatus)"
              >
                {{ task.leadStatus ? "Client" : "Lead" }}
              </b-badge>

              <b-form-textarea
                v-if="stage !== 'NEW'"
                v-model="task.comment"
                placeholder="Add a comment..."
                rows="2"
                class="mt-2"
              ></b-form-textarea>
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions, mapGetters } from "vuex";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BContainer,
  BTabs,
  BTab,
  BFormTextarea,
} from "bootstrap-vue";
export default {
  components: {
    draggable,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BContainer,
    BTabs,
    BTab,
    BFormTextarea,
  },
  data() {
    return {
      stages: ["NEW", "QUALIFICATION", "QUOTATION", "WON", "LOST"],
      tasks: [],
      selectedLeadCustomer: null,
      leadCustomerOptions: [{ value: null, text: "Leads / Customer Name" }],
      searchKeyword: "",
    };
  },

  computed: {
    ...mapGetters("opportunityModule", {
      pipelines: "pipelines",
      loadingpipe: "loading",
    }),
    filteredTasks() {
      let filtered = {};
      Object.keys(this.tasks).forEach((stage) => {
        filtered[stage] = this.tasks[stage].filter((task) => {
          const matchesLeadCustomer =
            !this.selectedLeadCustomer ||
            task.leadclient === this.selectedLeadCustomer;
          const matchesSearchKeyword =
            !this.searchKeyword ||
            task.name.toLowerCase().includes(this.searchKeyword.toLowerCase());
          return matchesLeadCustomer && matchesSearchKeyword;
        });
      });
      return filtered;
    },
  },
  methods: {
    ...mapActions("opportunityModule", [
      "getPipelineListAction",
      "updateOpportunityPipelinesAction",
      "addOpportunitiesAction",
    ]),
    statusVariant(isClient) {
      if (isClient === true) {
        return "success";
      } else {
        return "danger";
      }
    },
    showErrorMessages(error) {
      if (error.response && error.response.data && error.response.data.errors) {
        let errorMessages = [];
        const errors = error.response.data.errors;
        for (const key in errors) {
          if (errors.hasOwnProperty(key)) {
            errors[key].forEach((message) => {
              errorMessages.push(`${key}: ${message}`);
            });
          }
        }
        const errorMessage = errorMessages.join("\n");
        this.$swal({
          title: "Error",
          text: `There was an error updating the stage: ${errorMessage}`,
          icon: "error",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } else {
        console.error("Error: ", error);
        this.$swal({
          title: "Error",
          text: "An unexpected error occurred. Please try again.",
          icon: "error",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    populateTasks(pipelines) {
      this.tasks = {
        NEW: [],
        QUALIFICATION: [],
        QUOTATION: [],
        WON: [],
        LOST: [],
      };

      pipelines.forEach((pipeline) => {
        if (pipeline.opportunities && pipeline.opportunities.length > 0) {
          pipeline.opportunities.forEach((opportunity) => {
            const task = {
              id: opportunity.id,
              name: `Opportunity: ${opportunity.name || "No Opportunity Name"}`,
              leadclient: pipeline.leadName || "No Lead Name",
              leadClientID: pipeline.leadClientID,
              description: opportunity.description,
              stage: opportunity.stage,
              comment: opportunity.comments || "",
            };
            if (this.tasks.hasOwnProperty(opportunity.stage.toUpperCase())) {
              this.tasks[opportunity.stage.toUpperCase()].push(task);
            }
          });
        } else {
          const task = {
            id: pipeline.leadID,
            name: pipeline.leadName || "No Lead Name",
            stage: "NEW",
            leadStatus: pipeline.isClient,
            comment: "",
          };
          this.tasks.NEW.push(task);
        }
      });

      const leadCustomerSet = new Set();
      pipelines.forEach((pipeline) => {
        leadCustomerSet.add(pipeline.leadName || "No Lead Name"); // Updated to remove prefix
      });

      this.leadCustomerOptions = [
        { value: null, text: "Leads / Customer Name" },
        ...Array.from(leadCustomerSet).map((name) => ({
          value: name,
          text: name,
        })), // Display only the name
      ];
    },

    async onDragEnd(stage, event) {
      const fromStage = stage;
      const toStage = event.to.dataset.stage.toUpperCase();
      const movedTaskId = event.item.dataset.id;

      const draggedTask = this.tasks[fromStage].find(
        (task) => task.id === movedTaskId
      );

      if (
        fromStage !== "NEW" &&
        toStage !== "NEW" &&
        (!draggedTask.comment || draggedTask.comment.trim() === "")
      ) {
        this.$swal({
          title: "Error",
          text: "Cannot move the task without a comment.",
          icon: "error",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        await this.loadPipelines();
        return;
      }

      const allowedTransitions = {
        NEW: ["QUALIFICATION", "LOST"],
        QUALIFICATION: ["QUOTATION", "LOST"],
        QUOTATION: ["QUALIFICATION", "WON", "LOST"],
        LOST: ["NEW"],
        WON: [],
      };

      if (allowedTransitions[fromStage].includes(toStage)) {
        this.$swal({
          title: "Updating stage...",
          text: "Please wait while the opportunity stage is being updated...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        try {
          // Handle adding a new opportunity if moving from NEW to QUALIFICATION
          if (fromStage === "NEW" && toStage === "QUALIFICATION") {
            const payload = {
              leadClientID: draggedTask.id,
              name: draggedTask.name.replace("Lead/Customer Name: ", ""),
              status: "New",
            };
            await this.addOpportunitiesAction(payload);
          } else if (fromStage === "NEW" && toStage === "LOST") {
            const payload = {
              leadClientID: draggedTask.id,
              name: draggedTask.name.replace("Lead/Customer Name: ", ""),
              status: "ClosedLost",
            };
            await this.addOpportunitiesAction(payload);
          } else {
            // For other transitions, update the opportunity
            const payload = {
              id: movedTaskId,
              stage: toStage,
              comments: draggedTask.comment,
            };
            await this.updateOpportunityPipelinesAction(payload);
          }

          this.$swal.close();
          this.$swal({
            title: "Stage Change Successful",
            text: `Opportunity moved from ${fromStage} to ${toStage}.`,
            icon: "success",
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        } catch (error) {
          this.$swal.close(); // Close the swal loader
          this.showErrorMessages(error);
        }
      } else {
        this.$swal({
          title: "Stage change not allowed",
          text: "This transition is not permitted according to the business rules.",
          icon: "warning",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }

      // Reload pipelines to reflect the changes
      await this.loadPipelines();
    },

    getStageClass(stage) {
      return {
        "alert alert-secondary": stage === "NEW",
        "alert alert-warning": stage === "QUALIFICATION",
        "alert alert-info": stage === "QUOTATION",
        "alert alert-primary": stage === "WON",
        "alert alert-danger": stage === "LOST",
      };
    },

    async loadPipelines() {
      try {
        const response = await this.getPipelineListAction();
        this.populateTasks(this.pipelines);
        // Handle the response further if needed
      } catch (error) {
        console.error(error);
      }
    },
  },

  async mounted() {
    await this.loadPipelines();
  },
};
</script>

<style>
.kanban-board {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
}

.kanban-column {
  flex: 1;
  margin: 0 10px;
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .kanban-board {
    display: flex;
    overflow-x: scroll;
  }
  .kanban-column{
    flex:none;
    max-width:50%;
    }
}

.kanban-column .list-group-item {
  border: none;
  border-radius: 8px;
  margin-bottom: 0.75rem;
}

.task-title {
  font-weight: 600;
}

.task-description {
  font-size: 1rem;
  color: #90959a;
  margin-top: 0.5rem;
}
</style>
